import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AgentLoginInfoComponent = ({ onInnerFormChange, selectedAgents }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Phone"
              name="Phone"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.Phone',
                  selectedAgents?.Login
                )
              }}
              type="number"
              value={selectedAgents?.Login?.Phone}
          />
       <InputContainer
              label="Country Code"
              name="CountryCode"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.CountryCode',
                  selectedAgents?.Login
                )
              }}
              type="text"
              value={selectedAgents?.Login?.CountryCode}
          />
      <InputContainer
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.Email',
                  selectedAgents?.Login
                )
              }}
              type="text"
              value={selectedAgents?.Login?.Email}
          />
    </div>
 }
 expandedPanel="loginInfo"
 headerTitle="Login Info"
/>
</>
)
export default AgentLoginInfoComponent;
